import { Component, Vue } from 'vue-property-decorator';

import template from './statistics.vue';
import apiService from '@/services/api.service';
import { Statistics } from '@/definitions';
import { Action } from '@/store';

@Component({
  mixins: [template]
})
export default class Statisics extends Vue {
  stats: Statistics | null = null;

  async mounted() {
    try {
      this.stats = await apiService.getStats();
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.stats.retrieve_error', type: 'danger' });
    }
  }
}